import { Injectable, signal } from '@angular/core';
import { LassoDynamicFilterCommand } from '../report-groups-filter-criteria/report-groups-dynamic-filter/dynamic-filters/lasso-dynamic-filter.component ';

export enum ReportGroupModalView {
  Default = 'Default',
  Lasso = 'Lasso'
}

@Injectable()
export class ReportGroupModalService implements LassoDynamicFilterCommand {
  public readonly modalView = signal(ReportGroupModalView.Default);

  // activate lasso view using Command Pattern
  execute(): void {
    this.modalView.set(ReportGroupModalView.Lasso);
  }

  public activateDefaultView(): void {
    this.modalView.set(ReportGroupModalView.Default);
  }
}
